import moment from 'moment'
import clsx from 'clsx'
import { useController } from 'react-hook-form'

import Button from '../../../app/components/Button'

import styles from './CapacityConflictLaterTimesGrid.module.scss'
import { CapacityConflictFormValues } from './CapacityConflictSelectTimeStep'

type CapacityConflictLaterTimesGridProps = {
  times: string[]
}

export default function CapacityConflictLaterTimesGrid({
  times,
}: CapacityConflictLaterTimesGridProps) {
  const {
    field: { value: selectedTime, onChange },
  } = useController<CapacityConflictFormValues>({
    name: 'selectedPickupTime',
  })

  return (
    <section className={styles.grid}>
      {times.map(time => (
        <Button
          key={time}
          variant="secondary"
          className={clsx({ [styles.selected]: selectedTime === time })}
          onClick={() => onChange(time)}
        >
          {moment(time).format('LT')}
        </Button>
      ))}
    </section>
  )
}
